export default {
  colors: {
    primary: `#fdbf73`,
    background: `#001D44`,
    shape: `#1a4a50`,
    title: `#ff4800`,
    text: `#e0e0e0`,
    components: {
      blockquote: {
        background: `#1a4a50`,
        text: `#e0e0e0`,
      },
    },
  },
};
